import { Stores, useGlobalState } from "react-migration/lib";

import { Recipient } from "../../typings";

export function useActiveSiteBoundaryImageUrl() {
  const [{ recipients, activeRecipientId, siteBoundaryImageUrlBySiteId }] = useGlobalState(
    Stores.letter
  );

  const activeRecipient =
    recipients?.find((recipient) => recipient._id === activeRecipientId) ?? ({} as Recipient);

  return { siteBoundaryImageUrl: siteBoundaryImageUrlBySiteId[activeRecipient?.siteId] };
}
